import { get, httpDelete, patch, post } from 'store/http/httpAction';
import Enums from 'utils/EnumsManager';
import { queryByPaging } from '../../../../views/Task/flow/action';
import {
  ADD_NEW_SUBJECT,
  REMOVE_MY_SUBJECT,
  RESET_TASK,
  SET_RELATED_TO,
  SET_RELATED_TOS,
  SET_ROUTE_INFO,
  SET_TASK_ASSIGNEE,
  SET_TASK_ASSIGNEES,
  SET_TASK_FIELD,
  SET_TASK_FIELDS,
  SET_TASK_RECENT_ASSIGNEES,
  SET_TASK_SUBJECTS,
  SET_TASK_SUCCESS,
} from './actionTypes';

const { PhantomId } = Enums;

export const setRelatedTo = id => ({
  type: SET_RELATED_TO,
  payload: { id },
});

//
export const setAssignees = assignees => ({
  type: SET_TASK_ASSIGNEES,
  payload: { assignees },
});
export const tryFetchAssignees = (id, objectType) => dispatch =>
  get(`/admin/tasks/object/${objectType}/${id}/managers`, {}, dispatch).then((data) => {
    if (data) {
      dispatch(setAssignees(data.data));
    }
  } );

//
export const setTaskSubjects = (globalSubjects, mySubjects) => ({
  type: SET_TASK_SUBJECTS,
  payload: { globalSubjects, mySubjects },
});

export const tryFetchTaskSubjects = $ => dispatch =>
  get('/admin/tasks/subject/me', {}, dispatch).then((data) => {
    if (data && (!_.isEmpty(data.global) || !_.isEmpty(data.me))) {
      dispatch(setTaskSubjects(data.global, data.me));
    }
  });

//
export const addNewSubject = newSubject => ({
  type: ADD_NEW_SUBJECT,
  payload: { newSubject },
});

export const trySaveNewSubject = name => dispatch =>
  post(`/admin/tasks/subject/me?name=${name}`, {}, dispatch).then((data) => {
    if (data && !_.isEmpty(data.data)) {
      dispatch(addNewSubject(data.data));
    }
  });

//
export const removeMySubject = mySubjectId => ({
  type: REMOVE_MY_SUBJECT,
  payload: { mySubjectId },
});

export const tryDeleteSubject = id => dispatch =>
  httpDelete(`/admin/tasks/subject/me/${id}`, {}, dispatch).then((data) => {
    if (data) {
      dispatch(removeMySubject(id));
    }
  });

//
export const setRecentAssignees = recentAssignees => ({
  type: SET_TASK_RECENT_ASSIGNEES,
  payload: { recentAssignees },
});

export const tryFetchRecentAssignees = objectType => dispatch =>
  get(`/admin/tasks/object/${objectType}/recent_managers`, {}, dispatch).then((data) => {
    if (data && data.data) {
      dispatch(setRecentAssignees(data.data));
    }
  } );

//
export const setAssignee = assigneeId => ({
  type: SET_TASK_ASSIGNEE,
  payload: { assigneeId },
});
//
export const setFieldValue = (field, value) => ({
  type: SET_TASK_FIELD,
  payload: { field, value },
});

//
export const setSuccess = synced => ({
  type: SET_TASK_SUCCESS,
  payload: { synced },
});

export const setRouteInfo = info => ({
  type: SET_ROUTE_INFO,
  payload: { info },
});

//
export const trySaveNewTask = (taskId, taskData, action) => dispatch =>
  post('/admin/tasks/', { ...taskData }, dispatch).then((data) => {
    if (data && !_.isEmpty(data.data)) {
      dispatch(setSuccess(action));
    }
  });

//
export const tryUpdateTask = (taskId, taskData, action) => (dispatch, getState) =>
  patch(`/admin/tasks/${taskId}`, { ...taskData }, dispatch).then((data) => {
    if (data && !_.isEmpty(data.data)) {
      const taskDataTablePagination = getState().task.taskDataTablePagination;
      switch(action) {
        case 'saveAndNew':
        case 'save':
          dispatch(setSuccess(action));
          break;
        case 'complete':
          dispatch(queryByPaging(taskDataTablePagination.perPage, taskDataTablePagination.currentPage));
          break;
        default:
          return false;
      }
    }
  });

//
export const setTaskFields = data => ({
  type: SET_TASK_FIELDS,
  payload: { data },
});

export const setRelatedTos = data => ({
  type: SET_RELATED_TOS,
  payload: { data },
});

export const tryFetchRelatedTos = (id, type, taskId, taskData) => dispatch =>
  get(`/admin/tasks/related-object-options/${type}/${id}`, {}, dispatch).then((data) => {
    if (data && _.isArray(data.data)) {
      dispatch(setRelatedTos(data.data));
      if (taskId !== PhantomId) {
        dispatch(setRelatedTo(`${taskData.taskable_type}__${taskData.relate_user.id}`));
      }
      if (!_.isEmpty(data.data) && _.isNumber(data.default_index) && taskId === PhantomId) {
        const { default_index } = data;
        dispatch(setRelatedTo(`${data.data[default_index].taskable_type}__${data.data[default_index].taskable_id}`));
        if (data.data[default_index].owner && data.data[default_index].owner.id) {
          dispatch(setAssignee(data.data[default_index].owner.id));
        }
      }
    }
  });

export const tryFetchTask = (
  taskId,
  objectId,
  objectType,
  defaultStateId = '',
) => dispatch =>
  get(`/admin/tasks/${taskId}`, {}, dispatch).then((data) => {
    if (data && !_.isEmpty(data.data)) {
      if (defaultStateId === '') {
        dispatch(setTaskFields(data.data));
      } else {
        dispatch(setTaskFields({
          ...data.data,
          status_code: defaultStateId,
        }) );
      }
      // TODO: move out from this part for better performance
      dispatch(tryFetchAssignees(objectId, objectType));
      // TODO: move out from this part for better performance
      dispatch(tryFetchRecentAssignees(objectType));
      // TODO: move out from this part for better performance
      dispatch(tryFetchTaskSubjects());
      dispatch(tryFetchRelatedTos(objectId, objectType, taskId, data.data));
    }
  });

//
export const reset = () => ({
  type: RESET_TASK,
});



// WEBPACK FOOTER //
// ./src/components/page/TaskDetails/flow/actions.js